<template>
  <div class="Crisis_major_event">
    <div class="el_header">

      <el-form :inline="true" ref="numberValidateForm" :model="formInline" class="demo-form-inline">

          <el-form-item label="学生姓名">
            <el-input v-model="formInline.xuxm" placeholder="学生姓名"></el-input>
          </el-form-item>

          <el-form-item label="学号">
            <el-input v-model="formInline.xh" placeholder="学号"></el-input>
          </el-form-item>

          <el-form-item label="手机号">
            <el-input v-model="formInline.sjh" placeholder="手机号"></el-input>
          </el-form-item>

          <el-form-item label="培养单位">
            <el-input v-model="formInline.pydw" placeholder="培养单位"></el-input>
          </el-form-item>

          <el-form-item label="身份证号">
            <el-input v-model="formInline.sfzh" placeholder="身份证号"></el-input>
          </el-form-item>

          <el-form-item label="年级">
            <el-input v-model="formInline.hj" placeholder="年级"></el-input>
          </el-form-item>

          <el-form-item label="学位">
            <el-select v-model="formInline.xw" placeholder="学位">
              <el-option label="全部" value="全部"></el-option>
              <el-option label="学士" value="学士"></el-option>
              <el-option label="硕士" value="硕士"></el-option>
              <el-option label="博士" value="博士"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="记录类型">
            <el-select v-model="formInline.julx" placeholder="学位">
              <el-option label="全部" value="全部"></el-option>
              <el-option label="危机调整" value="危机调整"></el-option>
              <el-option label="谈话记录" value="谈话记录"></el-option>
              <el-option label="危机台账" value="危机台账"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="记录状态">
            <el-select v-model="formInline.juzt" placeholder="学位">
              <el-option label="全部" value="全部"></el-option>
              <el-option label="待审核" value="待审核"></el-option>
              <el-option label="已审核" value="已审核"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="onSubmit()">查询</el-button>
            <el-button type="primary" @click="resetForm()">重置</el-button>
            <el-button type="primary" @click="add()"> + 重大事件</el-button>
            <el-button type="primary" @click="addtalk()"> + 关联人物</el-button>
            <el-button type="primary" @click="duofanghuitan()">多方会谈</el-button>
          </el-form-item>
        </el-form>
    </div>

    <div class="Crisis_major_event_nav">
      <el-table ref="multipleTable" :data="BeforehandData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSecondSelection">

        <el-table-column type="selection" width="55" :selectable="selected">
          
        </el-table-column>

        <el-table-column prop="UserID" label="学号" width="120">
        </el-table-column>

        <el-table-column prop="RealName" label="姓名" width="120">
        </el-table-column>

        <el-table-column prop="Sex" label="性别" width="120">
        </el-table-column>

        <el-table-column prop="Degree" label="年级" width="120">
        </el-table-column>

        <el-table-column prop="DeptID" label="单位" width="120">
        </el-table-column>

        <el-table-column prop="Status" label="报名状态" width="120">
        </el-table-column>

        <el-table-column label="操作" show-overflow-tooltip>
          <template>
          </template>
        </el-table-column>

      </el-table>
    </div>
  </div>
</template>
<script>

import Crisis_addtalk from './Crisis_addtalk.vue';

export default {
  data() {
    return {
      formInline:{
        xuxm: '',
        xh: '',
        sjh: '',
        pydw: '',
        sfzh: '',
        hj: '',
        xw: '',
        julx: '',
        juzt: '',
      },
      BeforehandData:[]
    }
  },
  methods: {
    onSubmit(){
    },
    add() {
      this.$router.push('/Crisis/Crisis_addmajor_event');
    },
    addtalk() {
      this.$router.push('/Crisis/Crisis_addtalk');
    },
    duofanghuitan() {
      this.$router.push('/Crisis/Crisis_addmulti_talk');

    },
    resetForm(formName){
      this.formInline = {
        xuxm: '',
        xh: '',
        sjh: '',
        pydw: '',
        sfzh: '',
        hj: '',
        xw: '',
        julx: '',
        juzt: '',
      }
    },
    handleSecondSelection(val) {
      this.secondSelection = val;
    },
  },
  mounted() {

  }
}
</script>

<style>
  .Crisis_major_event{width: 100%;height: 100%;}
  .Crisis_major_event .el_header{background-color: rgb(255, 255, 255);padding: 10px;}
  .Crisis_major_event_nav{width: 100%;height: calc(100% - 160px);background-color: rgb(255, 255, 255);margin-top: 16px;}
</style>